import { Font } from "@react-pdf/renderer";

import CormorantRegular from "../../assets/fonts/CormorantGaramond-Regular.ttf";
import CormorantBold from "../../assets/fonts/CormorantGaramond-Bold.ttf";
import CormorantItalic from "../../assets/fonts/CormorantGaramond-Italic.ttf";

import LatoRegular from "../../assets/fonts/Lato-Regular.ttf";
import LatoBold from "../../assets/fonts/Lato-Bold.ttf";

Font.register({
  family: "Cormorant",
  fonts: [
    { src: CormorantRegular },
    { src: CormorantBold, fontWeight: "bold" },
    { src: CormorantItalic, fontStyle: "italic" },
  ],
});

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular },
    { src: LatoBold, fontWeight: "bold" },
  ],
});